import {extendTheme, theme as base} from '@chakra-ui/react'
import Accordion from './components/Accordion'
import Button from './components/Button'
import Container from './components/Container'
import Tabs from './components/tabs'
import colors from './foundations/colors'
import radii from './foundations/radii'
import Heading from './typography/heading'
import Text from './typography/text'

const customTheme = {
  fonts: {
    heading: `Nunito Sans, ${base.fonts?.heading}`,
    body: `Nunito Sans, ${base.fonts?.body}`,
  },
  colors,
  radii,
  components: {
    Heading,
    Text,
    Button,
    Container,
    Tabs,
    Accordion,
  },
  // initialColorMode: 'dark',
}

export default extendTheme(customTheme)
